import { AvailabilityFilter } from '@arrived/models';

export const availabilityFilterOptions = [
  { filter: null, label: { id: 'common.all' } },
  {
    filter: AvailabilityFilter.FOR_SALE,
    label: {
      id: 'common.for.sale',
    },
  },
  {
    filter: AvailabilityFilter.SOLD_OUT,
    label: {
      id: 'common.fully.funded',
    },
  },
  {
    filter: AvailabilityFilter.COMING_SOON,
    label: {
      id: 'common.coming.soon',
    },
  },
] as const;
